module.exports = __webpack_public_path__ + "static/img/loginback.b66d22b3.svg";